import { client } from "api";
import { UserRole } from "features/auth/types/user";

export type CreateUserRequest = {
  userName: string;
  email: string;
  phone: string;
  role: UserRole;
  companyId: string | null;
  controllerId: string | null;
  articleTime: string | null;
  articleTimeInCar: string | null;
  pyramidSignature: string | null;
  anstnrHogia: string | null;
  appleId: string | null;
  officeId: number | null;
  departmentIds: number[] | null;

  // Slated for deprecation
  admin: boolean;
  coworker: boolean;
  econ: boolean;
  externalInstaller: boolean;
  internalInstaller: boolean;
  sales: boolean;
};

export type CreateUserResponse = string;

export const createUser = (request: CreateUserRequest): Promise<CreateUserResponse> =>
  client.post<CreateUserResponse>(`/user/create`, request).then((res) => res.data);
